var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ucnwx0kq8c",
    d: "M0 0L250 0 250 250 0 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wjarfmpaqe",
    d: "M0 0.462L250 0.462 250 212 0 212z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4mnpv0d7qg",
    d: "M0 0.385L250 0.385 250 135 0 135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2yuea9cpni",
    d: "M0 0.308L250 0.308 250 58 0 58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "id5q33h4ek",
    d: "M0 0.001L250 0.001 250 57.693 0 57.693z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oi4olct4jm",
    d: "M0 0.001L250 0.001 250 134.616 0 134.616z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7852kx2qo",
    d: "M0 0L250 0 250 211.538 0 211.538z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wkvvy5pchq",
    d: "M0 0L250 0 250 250 0 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3h3y8be64s",
    d: "M0 0L173.077 0 173.077 250 0 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6cm71th2uu",
    d: "M0 0L96.154 0 96.154 250 0 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "74v7nwl98w",
    d: "M0.769 0L39.231 0 39.231 250 0.769 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "20xezdgy6y",
    d: "M0.847 0L97 0 97 250 0.847 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "czxxcp38vA",
    d: "M0.923 0L174 0 174 250 0.923 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i55gq7xk6C",
    d: "M0.001 0L250.001 0 250.001 250 0.001 250z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "0j02rra0wa",
    cx: 52,
    cy: 52,
    r: 52
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#FDC73D"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea7v07xllb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0j02rra0wa"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ea7v07xllb)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0l250 250C198.607 184.401 128.094 101.068 38.461 0H.001zM76.923 0C149.196 95.351 206.89 178.685 250 250 215.8 174.008 170.927 90.675 115.384 0h-38.46zM153.846 0C193.157 87.106 225.208 170.44 250 250c-15.022-81.968-34.252-165.302-57.693-250h-38.46zM230.77 0c7.788 83.485 14.198 166.818 19.23 250 5.032-83.182 11.442-166.515 19.231-250H230.77zM307.693 0C284.253 84.698 265.022 168.032 250 250c24.792-79.56 56.843-162.894 96.153-250h-38.461zM384.615 0C329.075 90.675 284.202 174.008 250 250 293.111 178.685 350.803 95.351 423.077 0h-38.462z",
    transform: "translate(-198 -198)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mkgf7d1ewd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ucnwx0kq8c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 0h-38.46C121.905 101.068 51.392 184.401 0 250L250 0z",
    mask: "url(#mkgf7d1ewd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iwaocyb2mf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wjarfmpaqe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 38.923V.463C148.932 90.093 65.6 160.606 0 212c71.315-43.112 154.648-100.804 250-173.077",
    mask: "url(#iwaocyb2mf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 115)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qhm9r33yih",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4mnpv0d7qg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 .385C159.325 55.925 75.992 100.799 0 135c79.56-24.791 162.894-56.844 250-96.154V.385z",
    mask: "url(#qhm9r33yih)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 192)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u7zn8umq8j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2yuea9cpni"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 .308C165.302 23.748 81.968 42.978 0 58c83.181-5.031 166.515-11.442 250-19.231V.308z",
    mask: "url(#u7zn8umq8j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wkw4l9jevl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#id5q33h4ek"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 19.23C166.515 11.443 83.181 5.033 0 0c81.968 15.022 165.302 34.252 250 57.693V19.23z",
    mask: "url(#wkw4l9jevl)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o6fayfr3pn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oi4olct4jm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 96.154C162.894 56.843 79.56 24.793 0 0c75.992 34.2 159.325 79.072 250 134.615V96.154z",
    mask: "url(#o6fayfr3pn)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v9px1v9vzp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p7852kx2qo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 173.077C154.648 100.804 71.315 43.111 0 0c65.6 51.392 148.932 121.906 250 211.538v-38.46z",
    mask: "url(#v9px1v9vzp)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "89m81dibrr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wkvvy5pchq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M250 250L0 0c51.393 65.6 121.906 148.932 211.54 250H250z",
    mask: "url(#89m81dibrr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c2lj5omdet",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3h3y8be64s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M173.077 250C100.804 154.648 43.111 71.314 0 0c34.201 75.991 79.073 159.325 134.615 250h38.462z",
    mask: "url(#c2lj5omdet)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(250 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "whhm00omov",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6cm71th2uu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96.154 250C56.844 162.894 24.792 79.56 0 0c15.022 81.968 34.252 165.302 57.693 250h38.461z",
    mask: "url(#whhm00omov)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(230 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ty5pkqld6x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#74v7nwl98w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.231 250C31.442 166.515 25.032 83.181 20.001 0 14.967 83.181 8.557 166.515.768 250h38.462z",
    mask: "url(#ty5pkqld6x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(153 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xnyxm3c66z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#20xezdgy6y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.308 250C62.748 165.302 81.978 81.968 97 0 72.208 79.56 40.157 162.894.847 250h38.46z",
    mask: "url(#xnyxm3c66z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(76 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4jv4n2g7dB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#czxxcp38vA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.385 250C94.927 159.325 139.8 75.991 174 0 130.888 71.314 73.197 154.648.923 250h38.462z",
    mask: "url(#4jv4n2g7dB)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198 -198) translate(0 250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ivnqphqr4D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i55gq7xk6C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.462 250C128.094 148.932 198.608 65.6 250 0L0 250h38.46z",
    mask: "url(#ivnqphqr4D)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 461.538C101.068 371.906 184.401 301.392 250 250 178.685 293.111 95.352 350.804 0 423.077v38.461zM0 384.615C90.675 329.072 174.008 284.202 250 250c-79.56 24.793-162.894 56.844-250 96.154v38.462z",
    transform: "translate(-198 -198)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 307.693c84.698-23.44 168.032-42.671 250-57.692-83.18 5.03-166.515 11.44-250 19.23v38.462zM0 230.769c83.485 7.79 166.82 14.2 250 19.23-81.968-15.021-165.302-34.251-250-57.691v38.46z",
    transform: "translate(-198 -198)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 153.846C87.106 193.157 170.44 225.208 250 250 174.008 215.8 90.675 170.927 0 115.384v38.462zM0 76.923C95.352 149.196 178.685 206.888 250 250 184.401 198.607 101.068 128.094 0 38.462v38.461z",
    transform: "translate(-198 -198)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#6DAEDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.37 17.792L13.37 31.224 0 31.224 0 47.564 13.37 47.564 13.37 61 29.63 61 29.63 47.564 43 47.564 43 31.224 29.63 31.224 29.63 17.792zM26.015 8.046L21.648.421 17.285 8.046 7.588 0 13.643 15.25 29.354 15.25 35.412 0z",
    transform: "translate(30.5 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.1f2d8f33.svg";
export { ForwardRef as ReactComponent };